import { combineReducers } from 'redux';
import CourseState from './CourseReducers';
import BlockState from './BlocksReducers';
import ChunkState from './ChunksReducers';
import ScrollState from './ScrollReducers';
import ContentState from './ContentStateReducers';
import BookmarksState from './BookmarksReducers';
import SideNavState from './SideNavReducers';
import RecentViewsState from './RecentlyViewedReducers';
import SearchState from './SearchReducers';
import CourseIndexState from './CourseIndexReducers';
import IframeModalState from './IframeModalReducers';
import LanguageState from './LanguageReducers';

const defaultState = {};

export default combineReducers({
  ScrollState,
  defaultState,
  ContentState,
  ChunkState,
  CourseState,
  BlockState,
  BookmarksState,
  RecentViewsState,
  SearchState,
  CourseIndexState,
  IframeModalState,
  SideNavState,
  LanguageState
});
